export const BASE_URL = `${window.location.protocol}//${window.location.hostname}/api`;

export const environments = {
  url_api: BASE_URL,
  url_login: BASE_URL + `/v1/auth`,
  url_recover_password: BASE_URL + `/v1/user/recover-password`,
  url_update_password: BASE_URL + `/v1/user/update-password`,
  url_user_create: BASE_URL + `/v1/user`,
  url_environment: BASE_URL + `/v1/environment`,
  url_active_environment: BASE_URL + `/v1/environment/active`,
  url_auditoria: BASE_URL + `/v1/auditoria`,
  url_rotina: BASE_URL + `/v1/rotina`,
  url_dashboard: BASE_URL + `/v1/dashboard`,
};
